var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41 10.705L6 9.29498L12 3.29498L18 9.29498L16.59 10.705L12 6.12498L7.41 10.705Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41 15L6 16.41L12 22.41L18 16.41L16.59 15L12 19.58L7.41 15Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18.5523 12 19 12.4477 19 13C19 13.5523 18.5523 14 18 14H6C5.44772 14 5 13.5523 5 13C5 12.4477 5.44772 12 6 12H18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandBlack);
export default __webpack_public_path__ + "static/media/ExpandBlack.dd4175bdd4976940bebd461779f1109b.svg";
export { ForwardRef as ReactComponent };